import axios from 'axios';

// 定义api的根路径
const myBaseURL = 'http://120.46.128.83/';

const service = axios.create({
    baseURL: myBaseURL,
})

// 请求拦截器
service.interceptors.request.use( config  => {
    // if (config.method === "post" || config.method === "get") {
    //     config.data = { unused: 0 }; // 解决请求添加不上Content-Type
    // }
    // 判断是否有token，若有则加入请求头中
    const getToken = localStorage.getItem("CX_TOKEN");
    if (getToken){
        config.headers['Authorization'] = "Bearer " + getToken;
    }
    if ( config.url.indexOf('sysFileInfo/preview') >= 0 ) {
        config.responseType = 'blob';
    }
    config.headers.Accept = "text/plain";
    try {
        config.headers['Content-Type'] = config.data?.get('apiType') === 'fromData' ? "application/x-www-form-urlencoded" : "application/json";
    }
    catch{
        config.headers['Content-Type'] =  "application/json";
    }
    
    
    return config;
}, error => {
    console.log("MyAxios Request Error ==========");
    return Promise.reject(error);
})

// // 响应拦截器
// service.interceptors.response.use(res => {
//     if (res.data.code !== 1000){
//         alert(res.data.msg)
//     }
//     return res.data;
// }, error => {
//     console.log("MyAxios Response Error ==========");
//     return Promise.reject(error)
// })

export default service